import React from "react";
import Layout from "../Layout/Layout";
const home = () => {
	return(
	    <>
		    Dashboard
		
		</>
	
	
	
	);
}
export default home;